import { WorkPlaceDto } from "src/dtos/workplace/workPlaceDto";
import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { getData } from "../utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/workplace`;

export const getAllWorkPlaces = async () => {
	const url = `${baseUrl}/list`;
	return await getData<ResponseDto<WorkPlaceDto[]>>(url);
};


export const getWorkPlaceList = async ( searchText:String) => {
	const url = `${baseUrl}/modal`;
	return await getData<ResponseDto<WorkPlaceDto[]>>(url, {
		params: {
			searchText
		}
	});
};